import { formatAmount } from '@/helpers/formatHelpers';
import { formatDate } from '@/helpers/dateHelpers/dateHelpers';
import { Card, CardContent } from '@/components/Card/Card';
import { WireStatus } from '@/bundle/shared/components/WireStatus/WireStatus';
import { WireType } from '@/types/wireTypes';
import { amplitudeService } from '@/services/amplitudeService/amplitudeService';
import { AMPLITUDE_EVENTS } from '@/services/amplitudeService/amplitudeEvents';
import { getRecipientWireDetailsPath } from '../_Details/path/path';
import { useStatefulNavigation } from '@/hooks/useStatefulNavigation';

type RecipientWiresListType = {
  list: WireType[];
};

export const RecipientWiresList = ({ list }: RecipientWiresListType) => {
  const { navigateFrom } = useStatefulNavigation();

  const navigateToDetails = (wire: WireType) => {
    amplitudeService.logEvent(AMPLITUDE_EVENTS.RecipientViewsDetails, { status: wire?.status });

    navigateFrom(getRecipientWireDetailsPath(wire.id));
  };

  return (
    <>
      {list.map((wire) => {
        const transactionName = wire?.contract?.name;
        const { status, date_created, expected_payment_date, amount, name, id } = wire;
        const formattedCreationDate = formatDate(date_created);
        const formattedExpectedPaymentDate = formatDate(expected_payment_date);
        const isDocumentVerificationRequired = wire?.is_pd_provider_kyc_required;

        return (
          <Card
            key={id}
            title={name}
            header={name}
            meta={<WireStatus status={status} />}
            onClick={() => navigateToDetails(wire)}
            marker={isDocumentVerificationRequired && 'ID VERIFICATION'}
          >
            <CardContent name='Creation Date'>{formattedCreationDate}</CardContent>
            <CardContent name='Expected Date' ratio={2}>
              {formattedExpectedPaymentDate}
            </CardContent>
            <CardContent name='Amount'>{formatAmount(amount)}</CardContent>
            <CardContent name='Transaction Name' ratio={2}>
              {transactionName}
            </CardContent>
          </Card>
        );
      })}
    </>
  );
};
